import {
    useProviderConfig,
    useSecondLookIntegration,
    resolveFieldOrder,
    getPersonalInfoBaseFields,
    type ProviderFieldOverride,
} from '@servicetitan/financing-workflow-shared';
import { PERSONAL_INFO_FIELD_REGISTRY } from './fieldRegistry';

export function usePersonalInfoFields() {
    const config = useProviderConfig();
    const secondLookIntegration = useSecondLookIntegration();

    // Dynamic field overrides - add incomeType when Turns is enabled
    const dynamicOverrides: ProviderFieldOverride = {
        ...config.personalInfoFieldOverrides,
    };

    // Add incomeType field when Turns is fully enabled (for GreenSky and ServiceFinance only)
    // Note: GoodLeap always has incomeType in its static config, not dynamic
    const hasIncomeTypeInConfig =
        config.personalInfoFieldOverrides?.additions?.includes('incomeType');
    if (secondLookIntegration.isEnabled && !hasIncomeTypeInConfig) {
        const incomeFieldName = config.useAnnualIncome ? 'annualIncome' : 'grossMonthlyIncome';
        dynamicOverrides.insertions = [
            ...(dynamicOverrides.insertions ?? []),
            { after: incomeFieldName, fields: ['incomeType'] },
        ];
    }

    const fieldOrder = resolveFieldOrder(
        getPersonalInfoBaseFields(config.useAnnualIncome),
        dynamicOverrides,
    );

    return { fieldOrder, fieldRegistry: PERSONAL_INFO_FIELD_REGISTRY };
}
